import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import style from './ImagePreviewModal.module.scss';

const ImagePreviewModal = ({ imagesArr, handleCloseImagePreviewModal, initialIndex }) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  const showNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % imagesArr.length);
  };

  const showPrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + imagesArr.length) % imagesArr.length);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      handleCloseImagePreviewModal();
    } else if (event.key === 'ArrowRight') {
      showNext();
    } else if (event.key === 'ArrowLeft') {
      showPrev();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <section className={`modal ${style.Modal}`}>
      <div className={`${style.Content} modal_content modal_small fadeInUpTop`}>
        <div className="modal_body p-40">
          <div
            role="presentation"
            className={`${style.HeadClose} modal_close icon`}
            onClick={handleCloseImagePreviewModal}
          />
          <div className={`${style.preview_slide}`}>
            <div className={`${style.gallpop_fullbox}`}>
              <div className={`${style.gallpop_fullimgbox}`}>
                <div className={`${style.gallpop_fullimginner}`}>
                  <div className={`${style.gallpop_fullimg}`}>
                    <img
                      className={`${style.full_image}`}
                      alt={`Img_${currentIndex + 1}`}
                      src={imagesArr[currentIndex]?.url}
                    />
                  </div>
                </div>
                <div className={`${style.gallpop_fullnextprev}`}>
                  <div role="presentation" className={`${style.fullprev} icon`} onClick={showPrev} />
                  <div role="presentation" className={`${style.fullnext} icon`} onClick={showNext} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

ImagePreviewModal.propTypes = {
  handleCloseImagePreviewModal: PropTypes.func.isRequired,
  imagesArr: PropTypes.arrayOf(PropTypes.string).isRequired,
  initialIndex: PropTypes.number.isRequired,
};

export default ImagePreviewModal;
